export default function getNearestDate(
	dates: Date[],
	pivot?: Date,
	operator?: "floor" | "ceil",
): Date | null {
	if (!pivot) {
		return null;
	}
	const pivotTime = pivot.getTime();

	// Return immediately if there is an exact match.
	for (const date of dates) {
		if (date.getTime() === pivotTime) {
			return date;
		}
	}

	if (operator === "floor") {
		// For "floor", find the largest date that is less than the pivot.
		let candidate: Date | null = null;
		let maxDiff = Number.NEGATIVE_INFINITY;
		for (const date of dates) {
			const diff = date.getTime() - pivotTime;
			if (diff < 0 && diff > maxDiff) {
				maxDiff = diff;
				candidate = date;
			}
		}
		return candidate;
	}
	if (operator === "ceil") {
		// For "ceil", find the smallest date that is greater than the pivot.
		let candidate: Date | null = null;
		let minDiff = Number.POSITIVE_INFINITY;
		for (const date of dates) {
			const diff = date.getTime() - pivotTime;
			if (diff > 0 && diff < minDiff) {
				minDiff = diff;
				candidate = date;
			}
		}
		return candidate;
	}

	return null;
}
